export * from './simple-image-variant.pipe';
export * from './simple-image-variant.module';
